import Link from 'next/link';
import styled, { css } from 'styled-components';

import { color, spacing } from '~/theme';

export const LinkType = {
    default: 'default',
    footer: 'footer',
    error: 'error',
    node: 'node',
};

export const linkStyles: Record<keyof typeof LinkType, ReturnType<typeof css>> = {
    default: css`
        color: ${color.baseLink};
        text-decoration: underline;

        &:hover,
        &:focus {
            color: ${color.baseLinkHover};
        }

        &:active {
            color: ${color.baseLinkActive};
        }

        &:visited {
            color: ${color.baseLinkVisited};
        }
    `,

    error: css`
        color: ${color.calloutErrorLink};
        text-decoration: underline;

        &:hover,
        &:focus {
            color: ${color.calloutErrorLinkHover};
        }

        &:active {
            color: ${color.calloutErrorLinkActive};
        }

        &:visited {
            color: ${color.calloutErrorLink};
        }
    `,

    footer: css`
        color: ${color.palette.white};
        text-decoration: none;
        margin: ${spacing.spacing0} calc(${spacing.spacing6} + ${spacing.spacing2})
            ${spacing.spacing0} ${spacing.spacing0};
        padding: ${spacing.spacing2};

        &:hover,
        &:focus {
            color: ${color.palette.white};
            text-decoration: underline;
        }

        &:active {
            color: ${color.calloutErrorLinkActive};
        }

        &:visited {
            color: ${color.palette.white};
        }
    `,

    node: css`
        color: ${color.palette.black};
        text-decoration: none;
        &:hover,
        &:focus,
        &:active,
        &:visited {
            color: ${color.palette.black};
        }
    `,
};

export const StyledLink = styled(Link)<{ type: keyof typeof LinkType }>`
    cursor: pointer;
    ${props => linkStyles[props.type]};

    &:focus {
        box-shadow: 0 0 0 4px ${color.focusBlue};
        outline: 4px solid transparent;
        transition: box-shadow 0.1s ease-in-out;
    }
`;

export const StyledAnchor = styled.a<{ type: keyof typeof LinkType }>`
    cursor: pointer;
    ${props => linkStyles[props.type]};

    &:focus {
        box-shadow: 0 0 0 4px ${color.focusBlue};
        outline: 4px solid transparent;
        transition: box-shadow 0.1s ease-in-out;
    }
`;

export default StyledLink;
